import { registerQuery } from 'data-fetching-client';
import { fetchBusinessUnits } from 'MeetingsLib/api/businessUnitsAPI';
export default registerQuery({
  fieldName: 'businessUnits',
  args: [],
  fetcher: fetchBusinessUnits
});